export default "__VITE_ASSET__CFutEbqh__"